import type { MediaKind } from "../domain/types";

/**
 * Contract for the backend sign endpoint.
 *
 * POST {signUrl}
 * Body: MediaSignRequest
 * Response: MediaSignResponse
 *
 * Then client PUTs the file bytes to uploadUrl (presigned).
 */

export interface MediaSignRequest {
  storageKey: string;
  contentType: string;
  sizeBytes: number;
  userId: string;
  assetId: string;
  kind: MediaKind;
  fileName: string;
  provider: "s3" | "r2" | "supabase";
}

export interface MediaSignResponse {
  /** Presigned PUT (or POST) URL for the raw bytes */
  uploadUrl: string;
  /** Durable HTTPS URL for later preview (CDN / public bucket / signed GET) */
  publicUrl: string;
  /** Optional extra headers required by the PUT (e.g. x-amz-acl) */
  uploadHeaders?: Record<string, string>;
  /** Defaults to PUT */
  uploadMethod?: "PUT" | "POST";
  /** Optional expiry hint (ISO) — informational */
  expiresAt?: string;
}

export class MediaUploadError extends Error {
  readonly stage: "config" | "sign" | "put" | "adapter";
  readonly status?: number;

  constructor(
    message: string,
    stage: MediaUploadError["stage"],
    status?: number
  ) {
    super(message);
    this.name = "MediaUploadError";
    this.stage = stage;
    this.status = status;
  }
}
